import { render, staticRenderFns } from "./BizDirectInvoiceList.vue?vue&type=template&id=8c59d21c&scoped=true&"
import script from "./BizDirectInvoiceList.vue?vue&type=script&lang=js&"
export * from "./BizDirectInvoiceList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c59d21c",
  null
  
)

export default component.exports